import React, { Component } from 'react'
import { Modal, ModalHeader, ModalBody, Button} from 'reactstrap'
import deleteRecord from '../../../helpers/users/manageUsers/deleteRecord';
import queryString from 'query-string'
import findRecord from '../../../helpers/users/manageUsers/findRecord';
import { BeatLoader } from 'react-spinners'

class DeleteConfirmationModal extends Component {

  state = {
    error: '',
    deleting: false,
  }

  deleteRec = (record) => {
    this.setState({deleting: true, error: ''})
    deleteRecord(record)
      .then(() => {
        this.setState({deleting: false, error: ''})
        let query = queryString.parse(this.props.location.search)
        delete query.m
        delete query.r
        this.props.history.push(`?${queryString.stringify(query)}`)
      })
      .catch((err) => {
        this.setState({error: 'Error deleting record.', deleting: false})
      })
  }

  render() {
    const { records, location, history } = this.props
    const { error, deleting } = this.state
    let search = ''
    if (location) {
      search = location.search
    }
   
    // determine if open, set how to toggle closed
    let qs = queryString.parse(search), isOpen = false
    const recordId = qs.r
    if (qs.m === 'delete') {
      isOpen = true
    }
    let noModal = Object.assign({}, qs)
    delete noModal.m
    delete noModal.r
    const closeModalLink = `?${queryString.stringify(noModal)}`
  
    // find the relevant record
    const record = findRecord(recordId, records)
  
    // enables closing the modal
    function toggle () {
      history.push(closeModalLink)
    }
  
    return (
      <Modal isOpen={isOpen} toggle={toggle} className={'modal-primary'}>
        <ModalHeader toggle={toggle}>Confirm Delete</ModalHeader>
        <ModalBody>
          {record && record.role
            ? <p>Are you sure you want to delete {record && record.fullName}'s account?</p>
            : <p>Are you sure you want to delete {record && record.name}?</p>
          }
          {error
            ? <p>{error}</p>
            : null
          }
          <Button onClick={() => this.deleteRec(record)}>
            {deleting
              ? <BeatLoader loading={deleting} />
              : 'Delete'
            }
          </Button>
          <Button onClick={toggle}>Cancel</Button>
        </ModalBody>
      </Modal>
    )
  }
}

export default DeleteConfirmationModal


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/DeleteConfirmationModal.js